import { useRouter } from "hooks";
import { useScrollToTopOnCategory } from "hooks/useScrollToTop";
import { PAGE_TYPES } from "enums/pageModules";
import Page from "components/Page";

const Category = () => {
  const {
    query: { slug },
  } = useRouter();

  useScrollToTopOnCategory();

  return <Page slug={slug} type={PAGE_TYPES.CATEGORY} />;
};
export default Category;
